<template>
		<div class="mt-5">
			<template v-if="!loading">
				<v-row>
					<v-col cols="12" sm="12" md="12" class="pb-0 px-1 mb-3">
						<div class="d-block d-md-flex flex-row align-center justify-center">
							<div class="d-flex flex-grow-1 flex-shrink-1 px-2 mb-2">
								<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-lg text-center d-flex flex-column align-stretch h-100 w-100" height="100">
									<div class="d-block cl-secondary font-size-12 font-weight-500"><span class="d-block font-weight-600">Point RO Anda Saat Ini</span></div>
									<div class="d-flex flex-column align-center justify-center py-1">
										<div class="font-size-20 font-weight-600" :class="(currentPoint.point_repeat_order_reward_personal > 0) ? 'primary--text' : 'grey--text'">{{ currentPoint.point_repeat_order_reward_personal | toNumber }}</div>
									</div>
								</v-card>
							</div>
						</div>
					</v-col>
				</v-row>

				<v-row class="ml-0" v-if="listHistoryRewardPribadi.length > 0">
					<v-col cols="12" sm="12" md="6" class="pl-0 pb-0 flex-stretch" v-for="reward in listHistoryRewardPribadi" :key="reward.reward_id">
						<v-card class="elevation-0 rounded-lg hover-shadow fill-height">
							<div class="d-flex flex-wrap">
								<v-col cols="12" sm="4" md="5" class="d-flex flex-column align-center fill-height pa-4">
									<v-img width="80%" elevation="2" class="mx-auto hover-shadow" :src="(reward.reward_image_url) ? reward.reward_image_url : '/assets/icon/reward.svg'"></v-img>
									<div class="bottom-shadow"></div>
								</v-col>
								<v-col cols="12" sm="8" md="7" class="pl-0 pt-5 align-start">
									<div class="pb-0 pr-2 d-flex flex-row align-center justify-end mb-3">
										<v-chip
											small
											:color="getRewardStatus(reward.reward_qualified_status).color"
											class="font-weight-bold white--text text-uppercase"
										><v-icon small class="mr-1">{{ getRewardStatus(reward.reward_qualified_status).icon }}</v-icon>{{ getRewardStatus(reward.reward_qualified_status).label }}</v-chip>
									</div>
									<div class="pt-2 pb-3 px-3">
										<div class="font-size-14 cl-primary font-weight-600 text-uppercase">{{ reward.reward_qualified_reward_bonus | toNumber }}</div>
									</div>
									<div class="d-flex flex-wrap">
										<v-col cols="12" class="pb-0 pt-1 d-flex flex-row align-center justify-space-between">
											<div class="font-size-10 cl-grey">Nominal Reward</div>
											<div class="font-size-11 cl-secondary font-weight-600 text-right">{{ reward.reward_qualified_reward_bonus | toRupiah }}</div>
										</v-col>
										<v-col cols="12" class="pb-0 pt-1 d-flex flex-row align-center justify-space-between">
											<div class="font-size-10 cl-grey">Potongan Admin</div>
											<div class="font-size-11 cl-secondary font-weight-600 text-right">{{ reward.reward_qualified_reward_adm_charge + ' %' }}</div>
										</v-col>
										<v-col cols="12" class="pb-0 pt-1 d-flex flex-row align-center justify-space-between">
											<div class="font-size-10 font-weight-600 cl-grey">Reward Diberikan</div>
											<div class="font-size-11 cl-primary font-weight-600 text-right">{{ reward.reward_qualified_reward_nett_value | toRupiah }}</div>
										</v-col>

										<v-col cols="12" class="pb-2 pt-1 d-flex flex-row align-center justify-space-between">&nbsp;</v-col>
										<v-col cols="12" class="pb-0 pt-1 d-flex flex-row align-center justify-space-between">
											<div class="font-size-10 cl-grey">Pencapaian Reward Point</div>
											<div class="font-size-11 font-weight-600 text-right" :class="(reward.reward_qualified_point > 0) ? 'cl-primary' : 'red--text'">
												{{ reward.reward_qualified_point | toNumber }}
											</div>
										</v-col>
										<v-col cols="12" class="pb-0 pt-5 d-flex flex-row align-center justify-space-between">
											<div class="font-size-9 cl-grey">Tanggal Qualified</div>
											<div class="font-size-9 cl-grey font-weight-600 text-right">{{ reward.reward_qualified_date | tanggaljam }}</div>
										</v-col>
										<v-col cols="12" class="pb-1 pt-1 d-flex flex-row align-center justify-space-between" v-if="reward.reward_qualified_status !== 'pending'">
											<div class="font-size-9 cl-grey">{{ getRewardStatus(reward.reward_qualified_status).label }} pada</div>
											<div class="font-size-9 cl-grey font-weight-600 text-right">{{ reward.reward_qualified_status_datetime | tanggaljam }}</div>
										</v-col>
										<v-col cols="12" class="d-flex flex-row align-center justify-space-between"></v-col>
									</div>
								</v-col>
							</div>
						</v-card>
					</v-col>
				</v-row>
				<div class="mt-3" v-if="listHistoryRewardPribadi.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
								<NoData></NoData>
								<div class="pt-3 text-center cl-secondary">Tidak ada data reward yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>

				<div class="mt-3" v-if="listHistoryRewardPribadi.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="historyRewardPribadiPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Menampilkan {{ historyRewardPribadiPagination.total_display }} data dari total {{ historyRewardPribadiPagination.total_data }} data</div>
						</v-col>
						<v-col cols="4" sm="2" md="1">
							<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimit"></v-autocomplete>
						</v-col>
					</v-row>
				</div>
			</template>

			<template v-else>
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</template>
		</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	props: ['currentPoint'],
	components: {
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			rewardStatus: [
				{
					status: 'approved',
					color: 'success',
					label: 'Disetujui',
					icon: 'mdi-check-decagram-outline'
				},
				{
					status: 'pending',
					color: 'warning',
					label: 'Menunggu',
					icon: 'mdi-timer-sand'
				},
				{
					status: 'rejected',
					color: 'error',
					label: 'Ditolak',
					icon: 'mdi-close-circle-outline'
				}
			]
		}
	},
	computed: {
		...mapState('reward', ['listHistoryRewardPribadi', 'historyRewardPribadiPagination']),
	},
	methods: {
		...mapActions('reward', ['getHistoryRewardPribadi']),

		getRewardStatus(status) {
			const reward = this.rewardStatus.find(x => x.status === status)
			if (reward) return reward
			else {
				const nonreward = {
					status: '',
					color: 'secondary',
					label: 'Updated',
					icon: ''
				}
				return nonreward
			}
		},

		getData() {
			this.loading = true
			this.getHistoryRewardPribadi(this.queryString({limit:this.limit, page: this.page, params:this.params})).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
	},
	created(){
		this.$store.dispatch('setPageTitle', `Reward Pribadi Saya`)
		this.getData()
	}
};
</script>

